import React from 'react'

const Footer = () => {
    return (
        <footer id='footer' role='contentinfo'>
            <a href="mailto:rhthrck12@gmail.com" rel='noopener noreferrer'>rhthrck12@gmail.com</a>
            <p>이 사이트는 포트폴리오 목적으로 제작되었으며, 상업적인 용도로 사용되지 않습니다. 메인 애니메이션은 코드펜(CodePen)에서 가져왔으며, 모든 저작권은 해당 창작자에게 있습니다.</p>
        </footer>
    )
}

export default Footer